"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayClient = exports.GATEWAY_PLUGIN_ID = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const gateway_1 = require("./gateway");
const Client_1 = require("../common/Client");
const solana_gateway_ts_1 = require("@identity.com/solana-gateway-ts");
exports.GATEWAY_PLUGIN_ID = new web3_js_1.PublicKey('GgathUhdrCWRHowoRKACjgWhYHfxCEdBi5ViqYN6HVxk');
class GatewayClient extends Client_1.Client {
    constructor(program, devnet, governanceProgramId = Client_1.DEFAULT_GOVERNANCE_PROGRAM_ID) {
        super(program, devnet);
        this.program = program;
        this.devnet = devnet;
        this.governanceProgramId = governanceProgramId;
        this.requiresInputVoterWeight = true;
    }
    static connect(provider, devnet) {
        return __awaiter(this, void 0, void 0, function* () {
            // alternatively we could fetch from chain
            // const idl = await Program.fetchIdl(GATEWAY_PLUGIN_ID, provider);
            return new GatewayClient(new anchor_1.Program(gateway_1.IDL, exports.GATEWAY_PLUGIN_ID, provider), devnet);
        });
    }
    calculateVoterWeight(voter, realm, mint, inputVoterWeight) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const gatewayTokenPDA = yield this.getGatewayTokenPDA(voter, realm, mint);
                const gatewayToken = yield (0, solana_gateway_ts_1.getGatewayToken)(this.program.provider.connection, gatewayTokenPDA);
                // fail out if the token is not valid
                if (!gatewayToken || !gatewayToken.isValid())
                    return null;
                // otherwise, the input voter weight is passed through
                return inputVoterWeight;
            }
            catch (e) {
                console.log('Error fetching gateway token PDA', e);
                return null; // fail out if we can't get the registrar or gateway token PDA
            }
        });
    }
    getGatewayTokenPDA(voter, realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const registrar = yield this.getRegistrarAccount(realm, mint);
            if (!registrar) {
                throw new Error('No registrar found');
            }
            const { gatekeeperNetwork } = registrar;
            return (0, solana_gateway_ts_1.getGatewayTokenAddressForOwnerAndGatekeeperNetwork)(voter, gatekeeperNetwork);
        });
    }
    createVoterWeightRecord(voter, realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar } = this.getRegistrarPDA(realm, mint);
            const { voterWeightPk } = this.getVoterWeightRecordPDA(realm, mint, voter);
            return this.program.methods
                .createVoterWeightRecord(voter)
                .accounts({
                registrar,
                voterWeightRecord: voterWeightPk,
            })
                .instruction();
        });
    }
    createMaxVoterWeightRecord() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    updateVoterWeightRecord(voter, realm, mint, action, inputRecordCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar } = this.getRegistrarPDA(realm, mint);
            const { voterWeightPk } = this.getVoterWeightRecordPDA(realm, mint, voter);
            // if the previous plugin has a specific way of deriving the input voter weight, use it
            // otherwise derive it the default way.
            const [inputVoterWeightPk, gatewayToken] = yield Promise.all([
                this.getPredecessorVoterWeightRecordPDA(realm, mint, voter, inputRecordCallback),
                this.getGatewayTokenPDA(voter, realm, mint)
            ]);
            const ix = yield this.program.methods
                .updateVoterWeightRecord()
                .accounts({
                registrar,
                inputVoterWeight: inputVoterWeightPk,
                gatewayToken,
                voterWeightRecord: voterWeightPk,
            })
                .instruction();
            return { pre: [ix] };
        });
    }
    updateMaxVoterWeightRecord() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
}
exports.GatewayClient = GatewayClient;
//# sourceMappingURL=client.js.map